import { render, staticRenderFns } from "./DealListItem.vue?vue&type=template&id=139a06f8"
import script from "./DealListItem.vue?vue&type=script&lang=js"
export * from "./DealListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports